import React from "react";
import { Helmet } from "react-helmet-async";
import { useI18n } from "../context/I18nContext";

const SITE_NAME = "DeStoel.com";
const DEFAULT_OG_IMAGE = "https://destoel.com/api/static/generated/hero_main_v2_a.png";
const SITE_ORIGIN = "https://destoel.com";

/**
 * Per-page SEO/Helmet wrapper.
 *
 * Props:
 *   titleNl / titleEn      — page title without "| De Stoel" suffix (we append it)
 *   descNl  / descEn       — meta description (1 sentence ideal)
 *   path                   — current pathname (e.g. "/klassiekers/wassily-stoel")
 *   ogImage                — optional override; defaults to hero image
 *   ogType                 — defaults to "website" (use "article" for detail pages)
 */
export default function Seo({ titleNl, titleEn, descNl, descEn, path = "/", ogImage, ogType = "website" }) {
  const { lang } = useI18n();
  const title = `${(lang === "en" ? titleEn : titleNl) || SITE_NAME} | ${SITE_NAME}`;
  const description = (lang === "en" ? descEn : descNl) || "";
  const canonical = `${SITE_ORIGIN}${path}`;
  const image = ogImage || DEFAULT_OG_IMAGE;
  const ogLocale = lang === "en" ? "en_US" : "nl_NL";
  return (
    <Helmet>
      <html lang={lang} />
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content={ogType} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={image} />
      <meta property="og:locale" content={ogLocale} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
